import React from 'react'
import { Field } from 'formik'
import { Form } from '_zari/core'

const FlagLoteFormGroup = ({ iEnabled, iValue, fIsSubmitting }) => {
  return (
    <Field name='flagLote'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          disabled={!iEnabled || fIsSubmitting}
          checked={iValue}
          id='checkbox-flagLote'
          label='LOTE'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagLoteFormGroup)
